import { Injectable } from '@angular/core';
import { BaseAccessService } from '@zaoblako/web/core/models/enums/access-rules/base-access.service';
import { DebtsAccessRulesKeyEnum } from './debts-access-rules-key.enum';
import { DebtsAccessRulesConst } from './debts-access-rules.const';

@Injectable({
  providedIn: 'root'
})
export class DebtsAccessService extends BaseAccessService<DebtsAccessRulesKeyEnum> {
  public constructor() {
    super(DebtsAccessRulesConst);
  }

  public get debtsRights() {
    return {
      canReadDebtors: this.globalService.isAccessRule(
        DebtsAccessRulesConst[DebtsAccessRulesKeyEnum.DEBTS_DEBTS_DEBTORS_READ]
      ),

      canReadCredit: this.globalService.isAccessRule(
        DebtsAccessRulesConst[DebtsAccessRulesKeyEnum.DEBTS_DEBTS_CREDIT_READ]
      ),

      canReadDebit: this.globalService.isAccessRule(
        DebtsAccessRulesConst[DebtsAccessRulesKeyEnum.DEBTS_DEBTS_DEBIT_READ]
      ),

      canReadBillRegistry: this.globalService.isAccessRule(
        DebtsAccessRulesConst[DebtsAccessRulesKeyEnum.DEBTS_DEBTS_BILL_REGISTRY_READ]
      ),

      canWriteAutocheckBills: this.globalService.isAccessRule(
        DebtsAccessRulesConst[DebtsAccessRulesKeyEnum.DEBTS_DEBTS_AUTOCHECK_BILLS_WRITE]
      ),

      canReadMailing: this.globalService.isAccessRule(
        DebtsAccessRulesConst[DebtsAccessRulesKeyEnum.DEBTS_DEBTS_MAILING_READ]
      ),
      canWriteMailing: this.globalService.isAccessRule(
        DebtsAccessRulesConst[DebtsAccessRulesKeyEnum.DEBTS_DEBTS_MAILING_WRITE]
      ),

      canReadCashGap: this.globalService.isAccessRule(
        DebtsAccessRulesConst[DebtsAccessRulesKeyEnum.DEBTS_DEBTS_CASH_GAP_READ]
      ),

      canReadCreditDebitExclusion: this.globalService.isAccessRule(
        DebtsAccessRulesConst[DebtsAccessRulesKeyEnum.DEBTS_DEBTS_CREDIT_DEBIT_EXCLUSION_READ]
      ),
      canWriteCreditDebitExclusion: this.globalService.isAccessRule(
        DebtsAccessRulesConst[DebtsAccessRulesKeyEnum.DEBTS_DEBTS_CREDIT_DEBIT_EXCLUSION_WRITE]
      ),

      canReadDebtCollection: this.globalService.isAccessRule(
        DebtsAccessRulesConst[DebtsAccessRulesKeyEnum.DEBTS_DEBTS_DEBT_COLLECTION_READ]
      ),
      canWriteDebtCollection: this.globalService.isAccessRule(
        DebtsAccessRulesConst[DebtsAccessRulesKeyEnum.DEBTS_DEBTS_DEBT_COLLECTION_WRITE]
      ),

      canReadIntegrationEmail: this.globalService.isAccessRule(
        DebtsAccessRulesConst[DebtsAccessRulesKeyEnum.DEBTS_DEBTS_INTEGRATION_EMAIL_READ]
      ),
      canWriteIntegrationEmail: this.globalService.isAccessRule(
        DebtsAccessRulesConst[DebtsAccessRulesKeyEnum.DEBTS_DEBTS_INTEGRATION_EMAIL_WRITE]
      ),

      canReadIntegrationMainSms: this.globalService.isAccessRule(
        DebtsAccessRulesConst[DebtsAccessRulesKeyEnum.DEBTS_DEBTS_INTEGRATION_MAIN_SMS_READ]
      ),
      canWriteIntegrationMainSms: this.globalService.isAccessRule(
        DebtsAccessRulesConst[DebtsAccessRulesKeyEnum.DEBTS_DEBTS_INTEGRATION_MAIN_SMS_WRITE]
      )
    };
  }

  public get debtsPermissions() {
    return {
      canReadAllTasksInCollection: this.globalService.isAccessRule(
        DebtsAccessRulesConst[DebtsAccessRulesKeyEnum.DEBTS_DEBTS_DEBT_COLLECTION_READ_ALL_TASKS]
      )
    };
  }
}
